import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {OttokartLeadsWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/ottokartLeadsWorkspaceCapability/domain/OttokartLeadsWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttokartLeadsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottokartLeads> & {
    fixedUdoTemplates: {
        [OttokartLeadsWorkspaceCapabilityUdoTemplateKey.lead]: {
            udoAdditionalColumnIds: {
                city: Uuid;
                companyName: Uuid;
                email: Uuid;
                enquiry: Uuid;
                name: Uuid;
                ottokartStorefrontCustomerId: Uuid;
                pageUrl: Uuid;
                phone: Uuid;
                productDescription: Uuid;
                productRequirement: Uuid;
                source: Uuid;
                status: Uuid;
                utmParameters: Uuid;
            };
        };
    };
};

export const ottokartLeadsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [OttokartLeadsWorkspaceCapabilityUdoTemplateKey.lead]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                status: uuidZodValidator,
                name: uuidZodValidator,
                phone: uuidZodValidator,
                enquiry: uuidZodValidator,
                companyName: uuidZodValidator,
                email: uuidZodValidator,
                city: uuidZodValidator,
                productRequirement: uuidZodValidator,
                productDescription: uuidZodValidator,
                ottokartStorefrontCustomerId: uuidZodValidator,
                utmParameters: uuidZodValidator,
                source: uuidZodValidator,
                pageUrl: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<OttokartLeadsWorkspaceCapabilityUdoBindings>;
